import React from 'react';
import { Icon } from './Icon.js';
export const IconWindowTopFill12 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "12px", ...props },
        React.createElement("path", { d: "M9.25 11C10.7688 11 12 9.76878 12 8.25V3.75C12 2.23122 10.7688 1 9.25 1H2.75C1.23122 1 0 2.23122 0 3.75V8.25C0 9.76878 1.23122 11 2.75 11H9.25ZM2.75 6C2.33579 6 2 5.66421 2 5.25V3.75C2 3.33579 2.33579 3 2.75 3H9.25C9.66421 3 10 3.33579 10 3.75V5.25C10 5.66421 9.66421 6 9.25 6H2.75Z", fill: "currentColor" })));
};
//# sourceMappingURL=IconWindowTopFill12.js.map